<mat-card class="xandr-shares">
  <p class="mat-title">{{buyersName}}s</p>
  <mat-card-content>

    <div [ngSwitch]="showLoading()">
      <div class="form-input-container" *ngSwitchCase="false">
        <table>
          <tr *ngFor="let buyer of filteredSharedBuyers()">
            <td *ngIf="findCustomPrice(buyer) as customPrice" class="buyer-info">{{buyer.name}} ({{buyer.buyerId}}) - {{customPrice.priceCpm}} {{customPrice.currencyCode}} CPM - {{customPrice.lastModified}}</td>
            <td *ngIf="!findCustomPrice(buyer)" class="buyer-info">{{buyer.name}} ({{buyer.buyerId}})</td>
            <td style="text-align: right">
              <button *ngIf="shouldShowActions()" mat-icon-button matTooltip="Remove {{buyersName}}" (click)="deleteBuyer(buyer)">
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
            </td>
          </tr>
        </table>
      </div>

      <div class="form-input-container" *ngSwitchCase="false">
        <ng-container *ngIf="shouldShowActions()">
        <mat-form-field>
          <input class="buyerSearch" [formControl]="buyerControl" placeholder="Add {{buyersName}}"
                 aria-label="Add buyer" matInput [matAutocomplete]="buyers"
                 #autocompleteTrigger="matAutocompleteTrigger">
          <mat-autocomplete #buyers="matAutocomplete" ngDefaultControl
                            (optionSelected)="onBuyerSelected($event.option.value)">
            <mat-option *ngFor="let buyer of filteredBuyers | async" [value]="buyer">{{buyer.name}}
              ({{buyer.buyerId}})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <button color="accent"
                (click)="forceOpen($event);"
                mat-raised-button name="add-to-attribute" type="submit">
          <mat-icon>add</mat-icon>
        </button>
        </ng-container>
      </div>
      
      <mat-spinner *ngSwitchCase="true"></mat-spinner>
    </div>
  </mat-card-content>
</mat-card>




